import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const AuthCallback = () => {
  const location = useLocation();
  const nav = useNavigate();
  const { setUserAfterGoogle } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      nav("/entrar");
      return;
    }
    const sessionId = match[1];
    (async () => {
      try {
        const res = await api.post("/auth/google/session", { session_id: sessionId });
        setUserAfterGoogle(res.data.user, res.data.token);
        window.history.replaceState({}, "", "/painel");
        if (res.data.user.role === "admin") {
          nav("/admin", { replace: true, state: { user: res.data.user } });
        } else {
          nav("/painel", { replace: true, state: { user: res.data.user } });
        }
      } catch (e) {
        nav("/entrar?error=google");
      }
    })();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-950">
      <div className="text-center">
        <div className="animate-spin w-12 h-12 border-4 border-sky-500 border-t-transparent rounded-full mx-auto mb-4"></div>
        <p className="text-sky-400 font-mono text-sm uppercase tracking-widest">Autenticando...</p>
      </div>
    </div>
  );
};
